import { put, call } from 'redux-saga/effects';
import { createQadraSaga } from './shared';
import {
  LEADS_GET,
  LEADS_POST,
  LEADS_WARNING_MESSAGE,
  LEADS_PATCH,
  TICKETS_POST,
} from '../actions/types';
import { apiLeadsGet, apiLeadsPost, apiLeadsPatch, apiTicketsPost } from '../api/crm';
import { actionModalOpen } from '../actions';

function* leadsGet({ payload: { crmId } }) {
  const { leads } = yield call(apiLeadsGet, crmId);
  yield put({
    type: LEADS_GET._SUCCESS,
    payload: { leads },
  });
}

const watchLeadsGet = createQadraSaga(leadsGet, {
  action: LEADS_GET._REQUEST,
});

function* leadsPost({ payload: { name, email, state, phone, status, crmId } }) {
  yield call(apiLeadsPost, { name, email, state, phone, status, crmId });
  yield leadsGet({ payload: { crmId } });
  yield put({ type: LEADS_WARNING_MESSAGE, payload: 'delay' });
}

const watchLeadsPost = createQadraSaga(leadsPost, {
  action: LEADS_POST._REQUEST,
});

function* leadsPatch({ payload: { crmId, id, name, phone, status } }) {
  yield call(apiLeadsPatch, { id, name, phone, status });
  yield leadsGet({ payload: { crmId } });
}

const watchLeadsPatch = createQadraSaga(leadsPatch, {
  action: LEADS_PATCH._REQUEST,
});

function* ticketsPost({ payload: { email, name, subject, message, type, locationUrl } }) {
  yield call(apiTicketsPost, { email, name, subject, message, type, url: locationUrl });
  yield put(actionModalOpen('ModalTicketSuccess'));
}

const watchTicketsPost = createQadraSaga(ticketsPost, {
  action: TICKETS_POST._REQUEST,
});

export default [watchLeadsGet, watchLeadsPost, watchLeadsPatch, watchTicketsPost];
